import React from 'react';
import { Link } from 'react-router-dom';

export default function MentionsLegalesPage() {
  const S = ({ title, children }) => (
    <section style={{ marginBottom:36, paddingBottom:32, borderBottom:'1px solid rgba(140,106,90,.12)' }}>
      <h2 style={{ fontSize:'clamp(16px,2.5vw,20px)', fontWeight:700, marginBottom:14 }}>{title}</h2>
      <div style={{ fontSize:15, color:'#3A2810', lineHeight:1.75 }}>{children}</div>
    </section>
  );
  return (
    <div style={{ paddingTop:'var(--nav-h, 64px)', minHeight:'100vh', background:'var(--radar-cream)' }}>
      <div style={{ maxWidth:780, margin:'0 auto', padding:'clamp(32px,6vw,64px) var(--px, clamp(16px,5vw,40px))' }}>
        <p className="section-label" style={{ marginBottom:12 }}>Informations légales</p>
        <h1 style={{ fontSize:'clamp(28px,5vw,44px)', fontWeight:700, letterSpacing:'-.02em', marginBottom:40 }}>Mentions légales</h1>

        <S title="1. Éditeur du site">
          <p>Le site <strong>RADAR</strong> (https://radar-lejeu.fr/) est Jeu de piste collaboratif animé par le RESAM destiné aux 18-30 ans.</p>
          <br/>
          <p><strong>Raison sociale :</strong> RÉSAM — À compléter </p>
          <p><strong>Forme juridique :</strong> Association loi 1901</p>
          <p><strong>Adresse :</strong> [À compléter]</p>
          <p><strong>Email :</strong> <a href="mailto:contact@radar-course.fr" style={{ color:'var(--radar-deep)' }}>animation@resam.net</a></p>
        </S>

        <S title="2. Directeur de la publication">
          <p>[Nom du représentant légal], en qualité de responsable de l'association RÉSAM.</p>
        </S>

        <S title="3. Hébergement">
          <p><strong>Hébergeur :</strong> Gandi SAS</p>
          <p><strong>Adresse :</strong> 63-65 Boulevard Masséna, 75013 Paris, France</p>
          <p><strong>Site :</strong> <a href="https://www.gandi.net" target="_blank" rel="noopener noreferrer" style={{ color:'var(--radar-orange)' }}>www.gandi.net</a></p>
        </S>

        <S title="4. Propriété intellectuelle">
          <p>L'ensemble des contenus de ce site (textes, images, vidéos, logos, pictogrammes) sont protégés par le droit d'auteur et appartiennent à RADAR / RÉSAM ou à leurs auteurs respectifs. Toute reproduction sans autorisation écrite préalable est interdite.</p>
        </S>

        <S title="5. Limitation de responsabilité">
          <p>RADAR s'efforce d'assurer l'exactitude des informations publiées mais ne peut en garantir l'exhaustivité. RADAR décline toute responsabilité pour tout dommage résultant d'une utilisation du site ou d'une intrusion frauduleuse ayant entraîné une modification des informations.</p>
        </S>

        <S title="6. Liens hypertextes">
          <p>Le site peut contenir des liens vers des sites tiers. RADAR n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou leur politique de confidentialité.</p>
        </S>

        <S title="7. Droit applicable">
          <p>Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.</p>
        </S>

        <div style={{ display:'flex', gap:16, flexWrap:'wrap', marginTop:8 }}>
          <Link to="/confidentialite" style={{ color:'var(--radar-deep)', fontFamily:'var(--font-mono)', fontSize:12, letterSpacing:'.05em', textTransform:'uppercase' }}>Politique de confidentialité →</Link>
          <Link to="/cookies" style={{ color:'var(--radar-deep)', fontFamily:'var(--font-mono)', fontSize:12, letterSpacing:'.05em', textTransform:'uppercase' }}>Gestion des cookies →</Link>
        </div>

        <p style={{ marginTop:32, fontSize:12, color:'var(--radar-mid)', fontFamily:'var(--font-mono)' }}>
          Dernière mise à jour : {new Date().toLocaleDateString('fr-FR',{day:'numeric',month:'long',year:'numeric'})}
        </p>
      </div>
    </div>
  );
}
